<mat-card-title>
  <div class="container">
    <div class="title">{{ title }}</div>
    <!-- Decoration, not a control: the card title has nothing to show or hide.
         The mat-icon is hidden from assistive technology by Material's default. -->
    <div class="controls">
      <mat-icon>expand_more</mat-icon>
    </div>
  </div>
</mat-card-title>
